import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";
// import { headerPost } from "@/config"

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getListArticle(params) {
	return client.get("general/content/show", {
		params: params,
	});
}

function getDetailArticle(params) {
	return client.get("general/content/detail", {
		params: params,
	});
}

function getListCategory(params) {
	return client.get("general/category/show", {
		params: params,
	});
}

function getListArticleByCategory(params) {
	return client.get("general/content/show", {
		params: params,
	});
}

export default {
	getListArticle,
	getDetailArticle,
	getListCategory,
	getListArticleByCategory
};